import React from 'react';
import { StudyGuideQuizDataGrid } from './study-guide-quiz-data-grid';
import { DialogContent, DialogTitle } from '@/components/ui/dialog';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';

export function StudyGuideQuizModal(props) {
  const { data } = props;
  const playful = usePlayfulStudent();

  return (
    <DialogContent size="lg">
      <DialogTitle
        border
        style={playful ? { color: 'var(--color-secondary)' } : undefined}
      >
        Rendimento nos quizzes das aulas
      </DialogTitle>

      <StudyGuideQuizDataGrid
        data={data}
        height={366}
      />
    </DialogContent>
  );
}
